export enum AccessEnum {
  ITEM_LIBRARY = 1,
  ITEM_MODIFIER = 2,
  STOCK_CONTROL = 3,
  DISCOUNT_CENTRE = 4,
  MENU_LIBRARY = 5,
  SHOW_MANAGE_AVAILABILITY = 6,
  ALLOW_AUTO_ACCEPT_SETUP = 19,
  ALLOW_PREPTIME_UPDATE = 20,
  STAFF_MANAGEMENT = 7,
  CUSTOMER_MANAGEMENT = 8,
  ACTIVE_ORDERS = 9,
  COMPLETED_ORDERS = 10,
  APPAIR_MANAGEMENT = 11,
  ACCOUNTING_CHARTS = 12,
  JOURNALS = 13,
  HOURLY_SALES = 14,
  SALES_BY_ITEMS = 15,
  SETTINGS = 16,
  MANAGE_ACCOUNT = 17,
  DASHBOARD = 18,
}

export enum TimeClockStatesEnums {
  CLOCK_IN = 0,
  CLOCK_OUT = 1,
}

export enum StaffRateTypesEnum {
  HOURLY = 0,
  MONTHLY = 1,
}

export enum StaffRateBasesEnum {
  MONTHLY = 0,
  ANNUALLY = 1,
}

export enum StaffEmploymentTypes {
  FULL_TIME = 0,
  PART_TIME = 1,
  CONTRACT = 2,
}

export enum StaffLeaveAllowanceTypes {
  DAILY,
  HOURLY,
}

export enum StaffLeaveRequestDurationTypes {
  FULL_DAY,
  HALF_DAY,
  CUSTOM_HOURS,
}

export enum StaffLeaveRequestStatus {
  PENDING,
  APPROVED,
  REJECTED,
  CANCELLED,
}
